var map = {
	"./gaming-consoles/sonyps4slimplaystation.png": 3470,
	"./gaming-consoles/sonyps5slimplaystation.png": 2789,
	"./gaming-consoles/xboxseriess.png": 5334,
	"./gaming-consoles/xboxseriesx.png": 6063,
	"./headphones/BeatsSolo3.png": 5878,
	"./headphones/beatsstudiobuds.png": 5663,
	"./headphones/cobywirelessfolding.png": 9053,
	"./headphones/hdj-x5bt-wireless.png": 50,
	"./laptops/hpchromebook.png": 6624,
	"./laptops/hpomen.png": 8142,
	"./laptops/hpomengaming.png": 1782,
	"./laptops/hppavilion.png": 4982,
	"./laptops/hpvictus.png": 2515,
	"./laptops/macbookair2021.png": 1583,
	"./laptops/macbookair2022.png": 8527,
	"./laptops/macbookpro2021.png": 8100,
	"./laptops/macbookpro2022.png": 7819,
	"./phones/iPhone13.png": 5127,
	"./phones/iPhone13mini.png": 6989,
	"./phones/iPhone13pro.png": 1480,
	"./phones/iPhone13promax.png": 1419,
	"./phones/iPhone14.png": 6951,
	"./phones/iPhone14plus.png": 5897,
	"./phones/iPhone14pro.png": 6675,
	"./phones/iPhone14promax.png": 6496,
	"./phones/s21.png": 6877,
	"./phones/s21ultra.png": 6326,
	"./phones/s22.png": 9258,
	"./phones/s22ultra.png": 1448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4272;